__webpack_require__.p = "https://2026.stateofthemap.africa/";